module.exports = __webpack_public_path__ + "static/media/f_1.81522822.jpg";